<template>
	<div>
		<template v-if="$parent.data.results.length > 0 && !$parent.end">
			<div
				v-if="$parent.gPagination === 'loadmore'"
				class="row"
			>
				<div
					v-if="!$parent.end && haveMore"
					class="col text-center"
				>
					<a-button
						type="primary"
						:disabled="$parent.end"
						:loading="$parent.loading"
						@click="$parent.next"
					>
						Cargar más
					</a-button>
				</div>
			</div>

			<div
				v-else-if="$parent.gPagination === 'infinite'"
				class="row"
			>
				<div
					v-if="!$parent.end"
					v-infinite-scroll="$parent.next"
					class="col text-center"
					:infinite-scroll-disabled="$parent.loading"
					infinite-scroll-distance="10"
				>
					<fa-icon
						size="2x"
						icon="circle-notch"
						:spin="$parent.loading"
					/>
				</div>
			</div>

			<div
				v-else
				class="row"
			>
				<div class="col text-center">
					<a-button
						class="mr-2"
						:disabled="$parent.page <= 1 || $parent.loading"
						@click="$parent.back"
					>
						<fa-icon icon="chevron-left" />
					</a-button>

					<a-button
						class="mr-2"
						:disabled="$parent.page <= 1 || $parent.loading"
						@click="$parent.back"
					>
						{{ $parent.page - 1 }}
					</a-button>

					<a-button type="primary">
						{{ $parent.page }}
					</a-button>

					<a-button
						class="ml-2"
						:disabled="$parent.page >= $parent.maxPage || $parent.loading"
						@click="$parent.next"
					>
						{{ $parent.page + 1 }}
					</a-button>

					<a-button
						class="ml-2"
						:disabled="$parent.page >= $parent.maxPage || $parent.loading"
						@click="$parent.next"
					>
						<fa-icon icon="chevron-right" />
					</a-button>
				</div>
			</div>
		</template>
		<div
			v-else-if="$parent.data.results.length <= 0"
			class="text-center pt-5"
		>
			<img
				src="@/system/assets/images/public/empty.png"
				class="mb-2"
			>

			<h4 class="text-gray-6">
				No se encontraron resultados
			</h4>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		haveMore() {
			if (this.$parent.data.total > this.$parent.data.results.length) return true;
			return false;
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
